import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by ARC PRIME"
      links={[
        {
          key: 'ARC PRIME',
          title: 'ARC PRIME',
          href: 'https://www.arcprime.com',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
